export default {
  // Language selection
  'settings.language.chinese': 'Chinese',
  'settings.language.english': 'English',

  // Service Types
  'settings.service.remitToChina': 'Remit to China',
  'settings.service.digitalWallet': 'Digital Wallet',

  // Terms and Conditions
  'settings.terms.title': 'Terms & Conditions',
  'settings.terms.title.label': 'Title',
  'settings.terms.content.label': 'Content',

  // Privacy Policy
  'settings.privacy.title': 'Privacy Policy',
  'settings.privacy.content.label': 'Content',

  // Content Types
  'settings.content.type.manual': 'Manual Edit',
  'settings.content.type.link': 'External Link',

  // Content Type Descriptions
  'settings.content.manual.description':
    'Edit bilingual content, the system will automatically display the corresponding version based on user language',
  'settings.content.link.description':
    'Provide external link, users will open it in a new window when clicked',

  // Link related
  'settings.content.link.placeholder': 'https://example.com/terms',
  'settings.content.link.preview': 'Preview Link',
  'settings.content.link.error': 'Please enter a valid URL address',

  // Validation messages
  'settings.validation.required.zh': 'Please enter Chinese content',
  'settings.validation.required.en': 'Please enter English content',

  // Common actions
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.edit': 'Edit',
  'common.preview': 'Preview',
  'common.confirm': 'Confirm',

  // ==================== Digital Wallet Settings ====================
  // Page title
  'settings.wallet.title': 'Digital Wallet White-Label Configuration',
  'settings.wallet.description':
    'Customize your digital wallet brand appearance, including Logo, theme colors, Slogan, etc.',

  // Logo configuration
  'settings.wallet.logo': 'Logo',
  'settings.wallet.logo.hint': 'Recommended size: 200x200px, supports PNG/JPG format',

  // Theme colors
  'settings.wallet.colors': 'Theme Colors',
  'settings.wallet.colors.preset': 'Quick Select',
  'settings.wallet.color.primary': 'Primary Color',
  'settings.wallet.color.primary.hint': 'Used for buttons, links and other primary elements',
  'settings.wallet.color.secondary': 'Secondary Color',
  'settings.wallet.color.secondary.hint': 'Used for emphasis, success states, etc.',

  // Background image
  'settings.wallet.background': 'Background Visual',
  'settings.wallet.background.hint': 'Recommended size: 1920x1080px, supports PNG/JPG format',

  // Brand Slogan
  'settings.wallet.slogan': 'Brand Slogan',
  'settings.wallet.slogan.label': 'Slogan Text',

  // Payment page configuration
  'settings.wallet.page.title': 'Page Title',
  'settings.wallet.page.description': 'Page Description',
  'settings.wallet.page.button': 'Button Text',
  'settings.wallet.successPage': 'Payment Success Page',
  'settings.wallet.successPage.config': 'Success Page Configuration',
  'settings.wallet.failurePage': 'Payment Failure Page',
  'settings.wallet.failurePage.config': 'Failure Page Configuration',

  // Action buttons
  'settings.wallet.export': 'Export Configuration',
  'settings.wallet.export.success': 'Configuration exported successfully',
  'settings.wallet.reset': 'Reset Configuration',
  'settings.wallet.reset.success': 'Reset to default configuration',
};
